/**
 * Reviews strip: native horizontal scroll with snap. The arrows move one card at a time
 * and the progress bar tracks the scroll position.
 */
module.exports = function () {
    document.querySelectorAll('.reviews-track').forEach(function (section) {
        const track = section.querySelector('.track');
        const bar = section.querySelector('.progress span');
        const buttons = section.querySelectorAll('.buttons button');

        if (!track || buttons.length !== 2)
            return;

        const [prev, next] = buttons;
        let target = 0;

        const step = function () {
            const card = track.querySelector('figure');
            return card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 24);
        };

        const update = function () {
            const max = track.scrollWidth - track.clientWidth;
            const visible = track.clientWidth / track.scrollWidth;

            if (bar) {
                bar.style.width = (visible * 100) + '%';
                bar.style.left = (max > 0 ? (track.scrollLeft / max) * (1 - visible) * 100 : 0) + '%';
            }

            prev.disabled = track.scrollLeft <= 2;
            next.disabled = track.scrollLeft >= max - 2;
        };

        [prev, next].forEach(function (button) {
            button.addEventListener('click', function () {
                const s = step();
                const max = track.scrollWidth - track.clientWidth;
                const from = Math.abs(target - track.scrollLeft) < s / 2 ? target : track.scrollLeft;

                target = Math.max(0, Math.min(max, Math.round(from / s) * s + s * +button.dataset.dir));
                track.scrollTo({left: target});
            });
        });

        track.addEventListener('scroll', function () {
            requestAnimationFrame(update);
        }, {passive: true});

        window.addEventListener('resize', update);
        update();
    });
};
